import { Button, Flex, Spacer } from '@chakra-ui/react'
import { capitalize } from 'lodash-es'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { RPCRefresh } from '@/client/rpc'
import {
  getLearningLabsConsentFormInputs,
  getLearningLabsConsentResponses,
} from '@/client/services/formInputs/learningLabsFormInputs'

import { useToaster } from '@/components/Toast/useToaster'
import Form from '@/components/UI/Form/Form'
import type { FormValues } from '@/components/UI/Form/types'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function LearningLabsConsentModal({
  open,
  onClose,
  type,
  worldSlug,
}: {
  open: boolean
  onClose: () => void
  type: 'learner' | 'tutor'
  worldSlug: string
}): JSX.Element {
  const toast = useToaster()
  const [handleSubmit] = useAPIWrapper(
    async (formValues: FormValues) => {
      const responses = getLearningLabsConsentResponses(formValues)
      await RPCRefresh.submitProgramConsent({
        type,
        worldSlug,
        responses,
      })
      toast({
        title: `Submitted ${capitalize(type)} Consent`,
        status: 'success',
      })
      onClose()
    },
    [onClose, toast, type, worldSlug],
    `Submit CAW ${capitalize(type)} Consent`
  )
  const inputs = getLearningLabsConsentFormInputs()

  return (
    <ModalV3
      open={open}
      title={`Complete ${capitalize(type)} Consent`}
      size="3xl"
      body={() => (
        <Form
          name="LearningLabsConsentForm"
          blocks={inputs}
          onSubmit={handleSubmit}
          FooterComponent={({ submitting }) => (
            <Flex mt="16px">
              <Spacer />
              <Button isLoading={submitting} type="submit">
                Submit
              </Button>
            </Flex>
          )}
        />
      )}
      onClose={onClose}
    />
  )
}
